<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <ItpBox
    spacing="pr-3 py-1"
    alignItems="center"
    v-if="loaded"
  >
    <ItpBadge
      :text="resource.inactive ? gettext('Inactive') : gettext('Active')"
      :variant="resource.inactive ? 'light' : 'primary'"
      no-box-shadow
    >
    </ItpBadge>
    <ItpButton
      size="sm"
      variant="light"
      :text="'Activate'|pgettext('UcResourceStatusCard')"
      class="mx-3 border"
      v-if="!resource.locked && resource.inactive"
      @click.stop.prevent="evh_3343864469950044_clickStopPrevent($event, {})"
    >
    </ItpButton>
    <ItpButton
      size="sm"
      variant="light"
      :text="'Inactivate'|pgettext('UcResourceStatusCard')"
      class="mx-3 border"
      v-if="!resource.locked && !resource.inactive"
      @click.stop.prevent="evh_1889980785424776_clickStopPrevent($event, {})"
    >
    </ItpButton>
  </ItpBox>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcResourceStatusCard extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  resource!: object;

  @Watch('resource')
  onResource(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("resource")
  }

  ux!: any;
  dataMembers = ['ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
      },
    }
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_3343864469950044_emit_3114_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_3343864469950044_emit_3114, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_3343864469950044_request_3112_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_3343864469950044_request_3112, alias=toggleState
    return {
      url: this.resource.links.self,
      method: "patch",
      data: {
        etag: this.resource.etag,
        inactive: !this.resource.inactive,
      },
    }
  }

  async evh_3343864469950044_clickStopPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3343864469950044_clickStopPrevent.executeFromDOM(this, event, scope);
  }

  async act_1889980785424776_emit_3118_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_1889980785424776_emit_3118, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_1889980785424776_request_3116_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1889980785424776_request_3116, alias=toggleState
    return {
      url: this.resource.links.self,
      method: "patch",
      data: {
        etag: this.resource.etag,
        inactive: !this.resource.inactive,
      },
    }
  }

  async evh_1889980785424776_clickStopPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1889980785424776_clickStopPrevent.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_3110: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_3109: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_3343864469950044_emit_3114: actions.EmitAction;
    evh_3343864469950044_success_3113: actions.EventHandlerImpl;
    act_3343864469950044_request_3112: actions.RequestAction;
    evh_3343864469950044_clickStopPrevent_3111: actions.EventHandlerImpl;
    evh_3343864469950044_clickStopPrevent: actions.EventHandlerGroup;
    act_1889980785424776_emit_3118: actions.EmitAction;
    evh_1889980785424776_success_3117: actions.EventHandlerImpl;
    act_1889980785424776_request_3116: actions.RequestAction;
    evh_1889980785424776_clickStopPrevent_3115: actions.EventHandlerImpl;
    evh_1889980785424776_clickStopPrevent: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_3110 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_3109 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_3110,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_3109],
      }
    );
    const act_3343864469950044_emit_3114 = new actions.EmitAction(
      {
        actionArgs: this.act_3343864469950044_emit_3114_getActionArgs,
        events: [],
      }
    );
    const evh_3343864469950044_success_3113 = new actions.EventHandlerImpl(
      {
        action: act_3343864469950044_emit_3114,
        event: "success",
        displayName: "emit",
      }
    );
    const act_3343864469950044_request_3112 = new actions.RequestAction(
      {
        actionArgs: this.act_3343864469950044_request_3112_getActionArgs,
        displayName: "toggleState",
        events: [evh_3343864469950044_success_3113],
      }
    );
    const evh_3343864469950044_clickStopPrevent_3111 = new actions.EventHandlerImpl(
      {
        action: act_3343864469950044_request_3112,
        event: "click.stop.prevent",
        displayName: "toggleState",
      }
    );
    const evh_3343864469950044_clickStopPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_3343864469950044_clickStopPrevent_3111],
      }
    );
    const act_1889980785424776_emit_3118 = new actions.EmitAction(
      {
        actionArgs: this.act_1889980785424776_emit_3118_getActionArgs,
        events: [],
      }
    );
    const evh_1889980785424776_success_3117 = new actions.EventHandlerImpl(
      {
        action: act_1889980785424776_emit_3118,
        event: "success",
        displayName: "emit",
      }
    );
    const act_1889980785424776_request_3116 = new actions.RequestAction(
      {
        actionArgs: this.act_1889980785424776_request_3116_getActionArgs,
        displayName: "toggleState",
        events: [evh_1889980785424776_success_3117],
      }
    );
    const evh_1889980785424776_clickStopPrevent_3115 = new actions.EventHandlerImpl(
      {
        action: act_1889980785424776_request_3116,
        event: "click.stop.prevent",
        displayName: "toggleState",
      }
    );
    const evh_1889980785424776_clickStopPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_1889980785424776_clickStopPrevent_3115],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_3110,
      evh_7315092382398562_reload_3109,
      evh_7315092382398562_reload,
      act_3343864469950044_emit_3114,
      evh_3343864469950044_success_3113,
      act_3343864469950044_request_3112,
      evh_3343864469950044_clickStopPrevent_3111,
      evh_3343864469950044_clickStopPrevent,
      act_1889980785424776_emit_3118,
      evh_1889980785424776_success_3117,
      act_1889980785424776_request_3116,
      evh_1889980785424776_clickStopPrevent_3115,
      evh_1889980785424776_clickStopPrevent,
      toggleState: act_1889980785424776_request_3116,
    }
  }
}

Vue.component("UcResourceStatusCard", UcResourceStatusCard);

</script>